export default "__VITE_ASSET__BP8QR1$D__"